/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
  <div class="contenedor-modales-alerta">
    <ModalError v-if="mostrarError" :mensajeExito="mensajeError" :mostrarExito="mostrarError"
      @cancelar="mostrarError = false" class="prioridad-absoluta" />
    <ModalExito v-if="mostrarExito" :mostrarExito="mostrarExito" class="prioridad-absoluta" />
  </div>

  <ModalBase v-show="mostrarModalTabla" class="provider-detail-modal modal-personalizado-ferre">
    <section class="modal-master-container">

      <header class="modal-fixed-header">
        <div class="header-content-wrapper">
          <div class="titulo-container">
            <h2 class="titulo">
              {{ tituloHeader }} <span class="tituloNombre">{{ ferreteriaLocal.Nombre }}</span>
            </h2>
          </div>
          <div class="botonesTitulo">
            <Button class="btn-icon add" @click="agregarNuevoInsumo" title="Agregar artículo">
              <i class="fa-solid fa-plus"></i>
            </Button>
            <Button class="btn-icon edit" @click="toggleEdicion" :class="{ 'is-editing': editando }">
              <i class="fa-solid fa-pen-to-square"></i>
            </Button>
            <Button class="btn-icon close" @click="cancelar" title="Cerrar">
              <i class="fa-solid fa-xmark"></i>
            </Button>
          </div>
        </div>

        <div class="separador"></div>

        <section class="info-grid">
          <div class="info-item"><strong>ID:</strong> {{ ferreteriaLocal.id_proveedor }}</div>
          <div class="info-item"><strong>Tel:</strong> {{ ferreteriaLocal.Telefono }}</div>
          <div class="info-item full-row"><strong>Domicilio:</strong> {{ ferreteriaLocal.Domicilio }}</div>
          <div class="info-item"><strong>Actualizado:</strong> {{ formatearFecha(ferreteriaLocal.Fecha_Actualizacion) }}
          </div>
        </section>
      </header>

      <main class="modal-scrollable-body">
        <div class="listado-insumos">
          <table class="tabla-escritorio">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Unidad</th>
                <th>Precio</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(insumo, index) in ferreteriaLocal.Insumos" :key="insumo.__temp_key || index">
                <td data-label="Producto">
                  <input v-if="editando || insumo.__es_nuevo" class="input-moderno" v-model="insumo.Nombre_Producto"
                    maxlength="50" :ref="insumo.__es_nuevo ? 'nuevoArticuloInput' : 'input_' + index + '_1'" />
                  <span v-else class="val-mobile">{{ insumo.Nombre_Producto }}</span>
                </td>
                <td data-label="Unidad">
                  <template v-if="editando || insumo.__es_nuevo">
                    <select class="input-moderno" v-model="insumo.Unidad">
                      <option value="Pieza">Pieza</option>
                      <option value="Metro">Metro</option>
                    </select>
                  </template>
                  <span v-else>{{ insumo.Unidad }}</span>
                </td>
                <td data-label="Precio">
                  <div v-if="editando || insumo.__es_nuevo" class="input-price-group">
                    <span>$</span>
                    <input class="input-moderno" v-model="insumo.Precio_Unitario" type="number" step="0.01" />
                  </div>
                  <span v-else class="precio-highlight">$ {{ formatearNumero(insumo.Precio_Unitario) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="!ferreteriaLocal.Insumos.length" class="empty-state">No hay insumos registrados.</div>
        </div>
      </main>

      <footer class="modal-fixed-footer" v-if="editando || ferreteriaLocal.Insumos.some(i => i.__es_nuevo)">
        <Button class="btn-guardar-principal" @click="guardarCambios" :disabled="isGuardando">
          {{ isGuardando ? 'GUARDANDO...' : 'GUARDAR CAMBIOS' }}
        </Button>
      </footer>
    </section>
  </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import ModalError from "../Modales/ModalError.vue";
import ModalExito from "../Modales/ModalExito.vue";
import dayjs from 'dayjs';
import materialsService from "@/services/materialsService";

export default {
  components: { Button, ModalBase, ModalError, ModalExito },
  props: {
    ferreteria: { type: Object, required: true },
    tituloHeader: { type: String, default: "Detalle de precios de" }
  },
  data() {
    return {
      ferreteriaLocal: { Nombre: '', id_proveedor: '', Telefono: '', Domicilio: '', Fecha_Actualizacion: '', Insumos: [] },
      mostrarModalTabla: true,
      editando: false,
      isGuardando: false,
      mostrarError: false,
      mostrarExito: false,
      mensajeError: ""
    };
  },
  watch: {
    ferreteria: {
      immediate: true,
      handler(nuevo) { if (nuevo?.id_proveedor) this.inicializarDatos(nuevo); }
    }
  },
  methods: {
    inicializarDatos(base) {
      this.ferreteriaLocal = {
        Nombre: base.Nombre || 'No disponible',
        id_proveedor: base.id_proveedor,
        Telefono: base.Telefono || 'No disponible',
        Domicilio: base.Domicilio || 'No disponible',
        Fecha_Actualizacion: base.Fecha_Actualizacion || dayjs().format('YYYY-MM-DD'),
        Insumos: []
      };
      this.obtenerInsumos(base.id_proveedor);
    },
    async obtenerInsumos(id) {
      try {
        const data = await materialsService.getMaterialsByProveedor(id);
        this.ferreteriaLocal.Insumos = data.map(m => ({
          Nombre_Producto: m.Articulo, Unidad: m.Unidad, Precio_Unitario: m.Precio,
          Id_Insumo: m.id_material, __es_nuevo: false, __temp_key: m.id_material,
          __original: JSON.stringify({ Articulo: m.Articulo, Unidad: m.Unidad, Precio: m.Precio })
        }));
      } catch (e) { this.lanzarError("Error al cargar materiales."); }
    },
    agregarNuevoInsumo() {
      if (this.ferreteriaLocal.Insumos.some(i => i.__es_nuevo)) {
        this.lanzarError("Guarda el artículo actual primero."); return;
      }
      this.ferreteriaLocal.Insumos.push({ Nombre_Producto: '', Unidad: 'Pieza', Precio_Unitario: 0, __es_nuevo: true, __temp_key: Date.now() });
      this.$nextTick(() => { const el = this.$refs.nuevoArticuloInput; if (el) el[0].focus(); });
    },
    async guardarCambios() {
      this.isGuardando = true;
      const modificados = this.ferreteriaLocal.Insumos.filter(i => i.__es_nuevo || this.haSidoModificado(i));
      if (modificados.length === 0) { this.editando = false; this.isGuardando = false; return; }
      try {
        for (const insumo of modificados) {
          const payload = { Articulo: insumo.Nombre_Producto, Unidad: insumo.Unidad, Precio: parseFloat(insumo.Precio_Unitario), id_proveedor: this.ferreteriaLocal.id_proveedor };
          if (insumo.__es_nuevo) {
            const res = await materialsService.createMaterial(payload);
            insumo.Id_Insumo = res.id_material; insumo.__es_nuevo = false;
          } else { await materialsService.updateMaterial(insumo.Id_Insumo, payload); }
        }
        this.mostrarExito = true;
        setTimeout(() => { this.mostrarExito = false; this.editando = false; }, 1500);
      } catch (e) { this.lanzarError("Error al guardar."); } finally { this.isGuardando = false; }
    },
    lanzarError(msj) { this.mensajeError = msj; this.mostrarError = true; setTimeout(() => { this.mostrarError = false; }, 2000); },
    haSidoModificado(i) {
      if (!i.__original) return false;
      const actual = JSON.stringify({ Articulo: i.Nombre_Producto, Unidad: i.Unidad, Precio: parseFloat(i.Precio_Unitario) });
      return actual !== i.__original;
    },
    cancelar() { this.$emit("cancelar"); },
    formatearNumero(v) { return Number(v || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 }); },
    formatearFecha(f) { return dayjs(f).format('DD/MM/YYYY'); },
    toggleEdicion() { this.editando = !this.editando; }
  }
};
</script>

<style scoped>
.modal-personalizado-ferre :deep(.contenido-modal) {
  margin: auto !important;
  width: 92% !important;
  max-width: 900px !important;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}

.modal-master-container {
  display: flex;
  flex-direction: column;
  background: white;
  width: 100%;
  height: 85vh;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-fixed-header {
  padding: 20px;
  flex-shrink: 0;
  background: white;
  border-bottom: 1px solid #eee;
}

.header-content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.titulo {
  font-size: 1.1rem;
  margin: 0;
}

.tituloNombre {
  color: #29b9f6;
  font-weight: bold;
  font-style: italic;
}

.botonesTitulo {
  display: flex;
  gap: 8px;
}

.btn-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-icon.is-editing {
  background: #29b9f6;
  color: white;
}

.btn-icon.close {
  background: #fee2e2;
  color: #ef4444;
}

.info-grid {
  display: flex;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 15px;
  margin-top: 12px;
  font-size: 0.85rem;
  flex-direction: column;
}

.full-row {
  grid-column: span 2;
}

.modal-scrollable-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 0 15px 15px 15px; 
  background: #fcfcfc;
  position: relative; 
}

.tabla-escritorio {
  width: 100%;
  border-collapse: collapse;
}

.tabla-escritorio thead th {
  background: #000;
  color: white;
  padding: 12px;
  text-align: left;
  font-size: 0.8rem;
  position: sticky;
  top: -1px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tabla-escritorio tbody tr {
  border-bottom: 1px solid #eee;
  transition: background 0.2s;
}

.tabla-escritorio tbody tr:hover {
  background-color: #f9f9f9; 
}

.tabla-escritorio td {
  padding: 12px;
  vertical-align: middle;
}

@media (max-width: 810px) {
  .tabla-escritorio thead {
    display: none;
  }

  .tabla-escritorio tr {
    display: block;
    background: white;
    margin: 0 auto 15px auto;
    padding: 15px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;
  }

  .tabla-escritorio td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border: none;
  }

  .tabla-escritorio td[data-label="Producto"] {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding-top: 5px;
  }

  .tabla-escritorio td::before {
    content: attr(data-label);
    font-weight: bold;
    color: #29b9f6;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .val-mobile {
    width: 100%;
    font-weight: 700;
    font-size: 1.05rem;
    color: #333;
    line-height: 1.2;
  }
}

.precio-highlight {
  color: #29b9f6;
  font-weight: bold;
  font-size: 1.2rem;
}

.modal-fixed-footer {
  padding: 15px 20px;
  background: white;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
}

.btn-guardar-principal {
  width: 100%;
  max-width: 400px;
  background: #29b9f6;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(152, 77, 33, 0.3);
}
</style>